// src/pages/DebtStudio/utils/formatters.js

export const fmtUSD = (n) =>
  (Number.isFinite(n) ? n : 0).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const parsePct3 = (s) => {
  if (typeof s !== "string") return 0;
  const cleaned = s.replace("%", "").trim();
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
};

export const fmtPct3 = (dec) =>
  Number.isFinite(dec) ? `${(dec * 100).toFixed(3)}%` : "0.000%";

export const fmtPct6 = (dec) =>
  Number.isFinite(dec) ? `${(dec * 100).toFixed(6)}%` : "0.000000%";

// ───────────────────────────────────────────
// MSRB G-33 Truncation utilities for PRICE
// ───────────────────────────────────────────
export const trunc3 = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.trunc(n * 1000) / 1000;
};

export const fmtTrunc3 = (value) => {
  const t = trunc3(value);
  return t == null ? "" : t.toFixed(3);
};

export const inputClass =
  "input bg-[hsl(var(--surface))] text-[hsl(var(--text))] placeholder:text-[hsl(var(--muted))] border border-[hsl(var(--border))]";
